export const siteVisitReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SITE_VISIT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_SITE_VISIT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        siteVisitList: action.payload,
      };

    case "GET_SITE_VISIT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_AGENT_SITE_VISIT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_AGENT_SITE_VISIT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        agentSiteVisitList: action.payload,
      };

    case "GET_AGENT_SITE_VISIT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_SITE_VISIT_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_SITE_VISIT_SUCCESS":
      return {
        ...state,
        loading: false,
        siteVisit: action.payload,
      };
    case "GET_SITE_VISIT_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "RESET_SITE_VISIT":
      return {
        ...state,
        siteVisit: null,
        error: null,
      };

    case "ADD_SITE_VISIT_RENTAL_REQUEST":
      return { ...state, loading: true };
    case "ADD_SITE_VISIT_RENTAL_SUCCESS":
      return { ...state, loading: false, addSiteVisitRental: action.payload };
    case "ADD_SITE_VISIT_RENTAL_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "STATUS_SITE_VISIT_RENTAL_REQUEST":
      return { ...state, loading: true };
    case "STATUS_SITE_VISIT_RENTAL_SUCCESS":
      return { ...state, loading: false, statusSiteVisitRental: action.payload };
    case "STATUS_SITE_VISIT_RENTAL_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "VIEW_SITE_VISIT_RENTAL_REQUEST":
      return { ...state, loading: true };
    case "VIEW_SITE_VISIT_RENTAL_SUCCESS":
      return { ...state, loading: false, siteVisitRental: action.payload };
    case "VIEW_SITE_VISIT_RENTAL_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "LIST_SITE_VISIT_RENTAL_REQUEST":
      return { ...state, loading: true };
    case "LIST_SITE_VISIT_RENTAL_SUCCESS":
      return { ...state, loading: false, siteVisitRentalList: action.payload };
    case "LIST_SITE_VISIT_RENTAL_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "RESET_SITE_VISIT_RENTAL":
      return { ...state, siteVisitRental: null, error: null };

    default:
      return state;
  }
};
